!function(t){"use strict";function e(){var e=this;e.reads=[],e.writes=[],e.raf=u.bind(t)}function n(t){t.scheduled||(t.scheduled=!0,t.raf(i.bind(null,t)))}function i(t){var e,i=t.writes,o=t.reads;try{o.length,r(o),i.length,r(i)}catch(t){e=t}if(t.scheduled=!1,(o.length||i.length)&&n(t),e){if(e.message,!t.catch)throw e;t.catch(e)}}function r(t){for(var e;e=t.shift();)e()}function o(t,e){var n=t.indexOf(e);return!!~n&&!!t.splice(n,1)}function s(t,e){for(var n in e)e.hasOwnProperty(n)&&(t[n]=e[n])}var u=t.requestAnimationFrame||t.webkitRequestAnimationFrame||t.mozRequestAnimationFrame||t.msRequestAnimationFrame||function(t){return setTimeout(t,16)};e.prototype={constructor:e,measure:function(t,e){var i=e?t.bind(e):t;return this.reads.push(i),n(this),i},mutate:function(t,e){var i=e?t.bind(e):t;return this.writes.push(i),n(this),i},clear:function(t){return o(this.reads,t)||o(this.writes,t)},extend:function(t){if("object"!=typeof t)throw new Error("expected object");var e=Object.create(this);return s(e,t),e.fastdom=this,e.initialize&&e.initialize(),e},catch:null};var exports=t.fastdom=t.fastdom||new e;"function"==typeof define?define(function(){return exports}):"object"==typeof module&&(module.exports=exports)}("undefined"!=typeof window?window:this);


!(function () {
    "use strict";
    function e(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function t(e, t) {
        for (var i = 0; i < t.length; i++) {
            var s = t[i];
            (s.enumerable = s.enumerable || !1), (s.configurable = !0), "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, i, s) {
        return i && t(e.prototype, i), s && t(e, s), e;
    }
    function s(e, t, i) {
        return t in e ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : (e[t] = i), e;
    }
    function n(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t &&
                (s = s.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                i.push.apply(i, s);
        }
        return i;
    }
    function r(e) {
        for (var t = 1; t < arguments.length; t++) {
            var i = null != arguments[t] ? arguments[t] : {};
            t % 2
                ? n(i, !0).forEach(function (t) {
                      s(e, t, i[t]);
                  })
                : Object.getOwnPropertyDescriptors
                ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i))
                : n(i).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(i, t));
                  });
        }
        return e;
    }
    var a,
        o = (function () {
            function t(i) {
                e(this, t),
                    (this.el = { container: i, text: i.querySelector("[data-maya-cursor-text]"), containers: null }),
                    (this.containers = []),
                    (this.props = { mouse: { x: 0, y: 0 }, current: { x: 0, y: 0 }, previous: { x: 0, y: 0 }, scroll: { y: 0, x: 0 }, ease: 0.15 }),
                    (this.bounds = { wWidth: null, wHeight: null }),
                    (this.timeout = null),
                    (this.raf = null),
                    this.init();
            }
            return (
                i(t, [
                    {
                        key: "init",
                        value: function () {
                            this.measure(), this.getContainers(), this.addEventListeners(), this.start();
                        },
                    },
                    {
                        key: "measure",
                        value: function () {
                            (this.bounds.wWidth = window.innerWidth), (this.bounds.wHeight = window.innerHeight);
                        },
                    },
                    {
                        key: "getContainers",
                        value: function () {
                            this.el.containers = document.querySelectorAll("[data-maya-cursor-container]");
                            for (var e = 0; e < this.el.containers.length; e++) {
                                var t = this.el.containers[e],
                                    i = t.getAttribute("data-maya-cursor-container");
                                this.containers.push({ container: t, attribute: i });
                            }
                        },
                    },
                    {
                        key: "addEventListeners",
                        value: function () {
                            window.addEventListener("mousemove", this._onMouseMove.bind(this), { passive: !0 });
                            for (var e = 0; e < this.el.containers.length; e++) {
                                var t = this.el.containers[e];
                                t.addEventListener("mouseenter", this._onMouseEnter.bind(this), { passive: !0 }), t.addEventListener("mouseleave", this._onMouseLeave.bind(this), { passive: !0 });
                            }
                        },
                    },
                    {
                        key: "removeEventListeners",
                        value: function () {
                            window.removeEventListener("mousemove", this._onMouseMove.bind(this));
                            for (var e = 0; e < this.el.containers.length; e++) {
                                var t = this.el.containers[e];
                                t.removeEventListener("mouseenter", this._onMouseEnter.bind(this)), t.removeEventListener("mouseleave", this._onMouseLeave.bind(this));
                            }
                        },
                    },
                    {
                        key: "_onMouseMove",
                        value: function (e) {
                            (this.props.mouse.x = e.pageX), (this.props.mouse.y = e.pageY), (this.props.current.x = e.pageX), (this.props.current.y = e.pageY);
                        },
                    },
                    {
                        key: "_onMouseEnter",
                        value: function (e) {
                            this.el.container.classList.add("is-active"),
                                this.el.text.removeEventListener("transitionend", this._onTransitionEnd.bind(this)),
                                this.el.text.addEventListener("transitionend", this._onTransitionEnd.bind(this)),
                                this.el.text.classList.add("is-transitioning"),
                                (this.el.text.innerHTML = e.currentTarget.dataset.mayaCursorContainer);
                        },
                    },
                    {
                        key: "_onMouseLeave",
                        value: function (e) {
                            this.el.container.classList.remove("is-active");
                        },
                    },
                    {
                        key: "_onTransitionEnd",
                        value: function () {
                            this.el.text.classList.remove("is-transitioning"), this.el.text.removeEventListener("transitionend", this._onTransitionEnd.bind(this));
                        },
                    },
                    {
                        key: "_render",
                        value: function () {
                            (this.props.previous.x = this.lerp(this.props.previous.x, this.props.current.x, this.props.ease)),
                                (this.props.previous.y = this.lerp(this.props.previous.y, this.props.current.y, this.props.ease)),
                                (this.el.container.style.transform = "translate3d(".concat(this.props.previous.x, "px, ").concat(this.props.previous.y - window.scrollY, "px, 0)")),
                                this.start();
                        },
                    },
                    {
                        key: "start",
                        value: function () {
                            this.raf = requestAnimationFrame(this._render.bind(this));
                        },
                    },
                    {
                        key: "stop",
                        value: function () {
                            cancelAnimationFrame(this.raf), (this.raf = null);
                        },
                    },
                    {
                        key: "lerp",
                        value: function (e, t, i) {
                            return (1 - i) * e + i * t;
                        },
                    },
                    {
                        key: "destroy",
                        value: function () {
                            this.removeEventListeners();
                        },
                    },
                ]),
                t
            );
        })(),
        l = (function () {
            function t(i) {
                e(this, t),
                    (this.selector = "maya-categories"),
                    (this.el = { container: i, links: i.querySelectorAll(".".concat(this.selector, "__routing-links ul li")), images: i.querySelectorAll("[data-maya-category-image]") }),
                    this.addEventListeners();
            }
            return (
                i(t, [
                    {
                        key: "addEventListeners",
                        value: function () {
                            for (var e = 0; e < this.el.links.length; e++) {
                                var t = this.el.links[e];
                                t.addEventListener("mouseenter", this._onLinkMouseEnter.bind(this)), t.addEventListener("mouseleave", this._onLinkMouseLeave.bind(this));
                            }
                        },
                    },
                    {
                        key: "_onLinkMouseEnter",
                        value: function (e) {
                            for (var t = 0; t < this.el.links.length; t++) {
                                var i = this.el.links[t],
                                    s = this.el.images[t];
                                i !== e.currentTarget
                                    ? (s.classList.remove("is-active"), i.classList.remove("is-active"), i.classList.add("is-inactive"))
                                    : (i.classList.remove("is-inactive"), i.classList.add("is-active"), s.classList.add("is-active"));
                            }
                        },
                    },
                    {
                        key: "_onLinkMouseLeave",
                        value: function () {
                            for (var e = 0; e < this.el.links.length; e++) {
                                var t = this.el.links[e],
                                    i = this.el.images[e];
                                t.classList.remove("is-active"), t.classList.remove("is-inactive"), i.classList.remove("is-active");
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        c = (function () {
            function t(i) {
                e(this, t), (this.el = { container: i, row: i.querySelector(".maya-home-our-story__gallery-row"), sliders: i.querySelectorAll("ul") }), (this.sliders = []), this.init();
            }
            return (
                i(t, [
                    {
                        key: "init",
                        value: function () {
                            this.setSliders(), this.addEventListeners();
                        },
                    },
                    {
                        key: "addEventListeners",
                        value: function () {
                            this.el.container.addEventListener("click", this._onGalleryClick.bind(this));
                        },
                    },
                    { key: "removeEventListeners", value: function () {} },
                    {
                        key: "_onGalleryClick",
                        value: function () {
                            this.el.row.classList.contains("is-active") || this.el.row.classList.add("is-active");
                            for (var e = 0; e < this.sliders.length; e++) {
                                var t = this.sliders[e];
                                t.flags.isAnimating || this.shuffle(t);
                            }
                        },
                    },
                    {
                        key: "shuffle",
                        value: function (e) {
                            var t = Math.floor(Math.random() * e.el.slides.length);
                            t != e.props.lastIndex ? (e.slideTo(t), (e.props.lastIndex = t)) : this.shuffle(e);
                        },
                    },
                    {
                        key: "setSliders",
                        value: function () {
                            var e = this;
                            this.el.sliders.forEach(function (t) {
                                return e.sliders.push(new u(t));
                            });
                        },
                    },
                ]),
                t
            );
        })(),
        u = (function () {
            function t(i) {
                e(this, t), (this.el = { container: i, slides: i.querySelectorAll("li") }), (this.props = { lastIndex: 0, activeIndex: 0 }), (this.flags = { isAnimating: !1 }), (this.active = null), (this.timeout = null);
            }
            return (
                i(t, [
                    {
                        key: "_onTransitionEnd",
                        value: function (e) {
                            e.currentTarget.classList.remove("is-inactive"), e.currentTarget.removeEventListener("transitionend", this._onTransitionEnd.bind(this)), (this.flags.isAnimating = !1), (this.active = null);
                        },
                    },
                    {
                        key: "slideTo",
                        value: function (e) {
                            if (!this.active && !this.flags.isAnimating) {
                                var t = this.el.container.querySelector(".is-active");
                                (this.flags.isAnimating = !0),
                                    (this.props.activeIndex = e),
                                    (this.active = t || this.el.container.querySelector("li:nth-child(1)")),
                                    this.active.classList.remove("skroll-in"),
                                    this.active.classList.remove("is-active"),
                                    this.active.removeEventListener("transitionend", this._onTransitionEnd.bind(this)),
                                    this.active.addEventListener("transitionend", this._onTransitionEnd.bind(this)),
                                    this.active.classList.add("is-inactive");
                                for (var i = 0; i < this.el.slides.length; i++) {
                                    var s = this.el.slides[i];
                                    s.classList.remove("skroll-in"), e === i && (s.classList.remove("is-inactive"), s.classList.add("is-active"));
                                }
                            }
                        },
                    },
                ]),
                t
            );
        })(),
        h = (function () {
            function t(i) {
                e(this, t),
                    (this.el = { container: i, swatches: i.querySelectorAll("[data-hover-swatches] > *"), slider: i.querySelector("[data-hover-swatches-slider]"), hide: i.querySelector("[data-hover-swatches-hide]") }),
                    (this.slides = []),
                    this.initialize(),
                    this.addEventListeners();
            }
            return (
                i(t, [
                    {
                        key: "initialize",
                        value: function () {
                            for (var e = 0; e < this.el.swatches.length; e++) {
                                var t = this.el.swatches[e],
                                    i = t.querySelector("input");
                                if (i.dataset.imageUrl) {
                                    var s = i.dataset.imageUrl.replace("{width}", "700"),
                                        n = document.createElement("div"),
                                        r = document.createElement("img");
                                    r.classList.add("lazyload"), r.setAttribute("src", s), n.appendChild(r), t.setAttribute("data-index", e), this.el.slider.appendChild(n), this.slides.push(n);
                                }
                            }
                        },
                    },
                    {
                        key: "addEventListeners",
                        value: function () {
                            for (var e = 0; e < this.el.swatches.length; e++) {
                                var t = this.el.swatches[e];
                                t.addEventListener("mouseenter", this._onMouseEnter.bind(this)), t.addEventListener("mouseleave", this._onMouseLeave.bind(this));
                            }
                        },
                    },
                    {
                        key: "removeEventListeners",
                        value: function () {
                            for (var e = 0; e < this.el.swatches.length; e++) {
                                var t = this.el.swatches[e];
                                t.removeEventListener("mouseenter", this._onMouseEnter.bind(this)), t.removeEventListener("mouseleave", this._onMouseLeave.bind(this));
                            }
                        },
                    },
                    {
                        key: "_onMouseEnter",
                        value: function (e) {
                            this.changeProductSlide(e);
                        },
                    },
                    {
                        key: "_onMouseLeave",
                        value: function () {
                            this.resetStyles();
                        },
                    },
                    {
                        key: "changeProductSlide",
                        value: function (e) {
                            var t = e.currentTarget,
                                i = parseInt(t.dataset.index);
                            this.el.slider.classList.add("is-hover"), this.el.hide.classList.add("is-hidden");
                            for (var s = 0; s < this.slides.length; s++) {
                                var n = this.slides[s];
                                n.classList.remove("is-active"), s === i && n.classList.add("is-active");
                            }
                        },
                    },
                    {
                        key: "resetStyles",
                        value: function () {
                            this.el.slider.classList.remove("is-hover"), this.el.hide.classList.remove("is-hidden");
                        },
                    },
                    {
                        key: "destroy",
                        value: function () {
                            this.removeEventListeners();
                        },
                    },
                ]),
                t
            );
        })(),
        d = { rootMargin: "0% 25%", threshold: 0.25, animateClassName: "skroll-in", disabledClassName: "skroll-disabled", enterEventName: "skroll:in", exitEventName: "skroll:out", selector: "[data-skroll]", once: !0, disabled: !1 },
        v = null,
        y = function (e, t) {
            var i = new CustomEvent(e, { bubbles: !0, detail: t });
            t.target.dispatchEvent(i);
        },
        m = function () {
            document.body.classList.add(d.disabledClassName);
        },
        f = function () {
            return d.disabled || ("function" == typeof d.disabled && d.disabled());
        },
        p = function (e, t) {
            e.forEach(function (e) {
                e.intersectionRatio >= d.threshold
                    ? (!(function (e) {
                          e.target.classList.add(d.animateClassName), y(d.enterEventName, e);
                      })(e),
                      d.once && t.unobserve(e.target))
                    : d.once ||
                      (function (e) {
                          e.target.classList.remove(d.animateClassName), y(d.exitEventName, e);
                      })(e);
            });
        },
        g = function () {
            document.body.classList.remove(d.disabledClassName),
                (v = new IntersectionObserver(p, { rootMargin: d.rootMargin, threshold: d.threshold })),
                [].filter
                    .call(document.querySelectorAll(d.selector), function (e) {
                        return !(function (e) {
                            return e.classList.contains(d.animateClassName);
                        })(e, d.animateClassName);
                    })
                    .forEach(function (e) {
                        return v.observe(e);
                    });
        },
        L = (function () {
            function t(i) {
                e(this, t),
                    (this.el = { container: i }),
                    (this.bounds = null),
                    (this.observer = null),
                    (this.raf = null),
                    (this.props = { previous: 0, current: 0, ease: 0.2, maxValue: null }),
                    (this.bounds = { top: null, height: null, width: null, wHeight: null }),
                    (this.top = 0),
                    (this.render = this.render.bind(this)),
                    this.init();
            }
            return (
                i(t, [
                    {
                        key: "init",
                        value: function () {
                            this.measure(), this.update(), this.start();
                        },
                    },
                    {
                        key: "measure",
                        value: function () {
                            var e = this.el.container.getBoundingClientRect();
                            (this.bounds.top = e.top), (this.bounds.height = e.height), (this.bounds.width = e.width), (this.bounds.wHeight = window.innerHeight);
                        },
                    },
                    {
                        key: "calculate",
                        value: function () {
                            this.top = window.scrollY;
                            var e = this.props.maxValue,
                                t = -1 * e,
                                i = this.bounds.top - this.top,
                                s = this.bounds.wHeight + 2 * this.bounds.height,
                                n = -1 * this.bounds.height * 2;
                            return Math.max(Math.min(this.map(i, s, n, t, e), e), t);
                        },
                    },
                    {
                        key: "update",
                        value: function () {
                            (this.props.maxValue = parseInt(this.el.container.getAttribute("data-offset-size"))), (this.props.current = this.calculate()), (this.props.previous = this.calculate());
                        },
                    },
                    {
                        key: "render",
                        value: function () {
                            (this.props.current = this.calculate()),
                                (this.props.previous = this.lerp(this.props.previous, this.props.current, this.props.ease)),
                                (this.el.container.style.transform = "translate3d(0, ".concat(this.props.previous, "px, 0)")),
                                this.start();
                        },
                    },
                    {
                        key: "start",
                        value: function () {
                            this.raf = requestAnimationFrame(this.render);
                        },
                    },
                    {
                        key: "stop",
                        value: function () {
                            cancelAnimationFrame(this.raf), (this.raf = null);
                        },
                    },
                    {
                        key: "map",
                        value: function (e, t, i, s, n) {
                            return ((e - t) * (n - s)) / (i - t) + s;
                        },
                    },
                    {
                        key: "lerp",
                        value: function (e, t, i) {
                            return (1 - i) * e + i * t;
                        },
                    },
                    {
                        key: "destroy",
                        value: function () {
                            (this.props = { previous: 0, current: 0, ease: 0.9, offsetDir: null, maxValue: null }), (this.el.container.style.transform = "");
                        },
                    },
                ]),
                t
            );
        })();
    (a = (function () {
        function t() {
            e(this, t),
                (this.el = { productItems: null, categories: null, cursor: null, gallery: null }),
                (this.flags = { isPointersRunning: !1 }),
                (this.categories = null),
                (this.cursor = null),
                (this.gallery = null),
                (this.hoverSwatches = []),
                (this.parallaxes = []),
                (this.activeHover = null),
                (this.origX = null),
                (this.timeout = null);
        }
        return (
            i(t, [
                {
                    key: "initialize",
                    value: function () {
                        var e = this;
                        history && history.scrollRestoration && (history.scrollRestoration = "manual"),
                            setTimeout(function () {
                                return e.initMayaHoverSwatches();
                            }, 1e3),
                            this.initMayaGlobal(),
                            this.initMayaSkroll(),
                            this.initMayaCursorJack(),
                            this.initMayaParallax(),
                            this.initMayaCategories(),
                            this.initMayaGallery(),
                            this.addEventListeners();
                    },
                },
                {
                    key: "initMayaGlobal",
                    value: function () {
                      if (document.querySelector(".Header__MainNav > ul > li > a") != null) {
                        document.querySelector(".Header__MainNav > ul > li > a").href = "javascript:void(0)";
                      }
                    },
                },
                {
                    key: "initMayaSkroll",
                    value: function () {
                        !(function () {
                            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : d;
                            if ((e !== d && (d = r({}, d, {}, e)), !window.IntersectionObserver))
                                throw (m(), Error("\n\t\t\tYour browser does not support IntersectionObserver!\n\t\t\tGet a polyfill from here:\n\t\t\thttps://github.com/w3c/IntersectionObserver/tree/master/polyfill\n\t\t"));
                            f() ? m() : g();
                        })();
                    },
                },
                {
                    key: "initMayaCursorJack",
                    value: function () {
                        document.body.classList.contains("template-index") && ((this.el.cursor = document.querySelector("[data-maya-cursor]")), (this.cursor = new o(this.el.cursor)));
                    },
                },
                {
                    key: "initMayaHoverSwatch",
                    value: function (e) {
                        this.hoverSwatches.push(new h(e));
                    },
                },
                {
                    key: "initMayaHoverSwatches",
                    value: function () {
                        if (((this.el.productsItems = document.querySelectorAll(".ProductItem")), this.el.productsItems))
                            for (var e = 0; e < this.el.productsItems.length; e++) {
                                var t = this.el.productsItems[e];
                                this.initMayaHoverSwatch(t);
                            }
                    },
                },
                {
                    key: "initMayaParallax",
                    value: function () {
                        if (document.body.classList.contains("template-index"))
                            for (var e = document.querySelectorAll("[data-maya-parallax]"), t = 0; t < e.length; t++) {
                                var i = e[t];
                                this.parallaxes.push(new L(i));
                            }
                    },
                },
                {
                    key: "initMayaCategories",
                    value: function () {
                        (this.el.categories = document.getElementById("shopify-section-maya-categories")), this.el.categories && (this.categories = new l(this.el.categories));
                    },
                },
                {
                    key: "initMayaGallery",
                    value: function () {
                        document.body.classList.contains("template-index") && ((this.el.gallery = document.querySelector("[data-maya-gallery]")), this.el.gallery && (this.gallery = new c(this.el.gallery)));
                    },
                },
                {
                    key: "addEventListeners",
                    value: function () {
                        var e = this;
                        if (document.body.classList.contains("template-product")) {
                            var t = document.querySelectorAll(".Product__Info .ColorSwatchList li");
                            document.addEventListener("variant:changed", this._onVariantChange.bind(this)),
                                document.addEventListener("product:added", function (e) {
                                    console.log(e.detail);
                                });
                            for (var i = 0; i < t.length; i++) {
                                var s = t[i];
                                s.addEventListener("mouseenter", this._showHoverImage.bind(this)), s.addEventListener("mouseleave", this._hideHoverImage.bind(this));
                            }
                        }
                        document.body.classList.contains("template-index") &&
                            window.addEventListener("scroll", function () {
                                clearTimeout(e.timeout),
                                    (e.timeout = null),
                                    e.flags.isPointersRunning || ((e.flags.isPointersRunning = !0), (document.body.style.pointerEvents = "none")),
                                    (e.timeout = setTimeout(function () {
                                        (e.flags.isPointersRunning = !1), (document.body.style.pointerEvents = "all");
                                    }, 300));
                            }),
                            document.addEventListener("theme:loading:end", function () {
                                e.destroyMayaHoverSwatches(), e.initMayaHoverSwatches();
                            });
                    },
                },
                {
                    key: "_onVariantChange",
                    value: function (e) {
                        this._hideHoverImage();
                        var t = document.querySelectorAll(".Product__Info .ColorSwatchList li"),
                            i = document.querySelectorAll(".Product__SlideshowDots .ColorSwatchList li"),
                            s = document.querySelectorAll(".Product__Info .SizeSwatchList li"),
                            n = document.querySelectorAll(".Product__SlideshowDots .SizeSwatchList li"),
                            r = document.querySelectorAll(".ProductForm__SelectedValue"),
                            a = e.detail.variant,
                            o = (a.id, a.title);
                        this.mapInputOptions(i, t), this.mapInputOptions(n, s);
                        for (var l = 0; l < r.length; l++) r[l].innerHTML = o;
                    },
                },
                {
                    key: "_showHoverImage",
                    value: function (e) {
                        if (!e.currentTarget.classList.contains("is-selected")) {
                            var t = [],
                                i = e.currentTarget.getAttribute("data-variant-option"),
                                s = document.querySelectorAll(".Product__Info .is-selected[data-variant-secondary-option]");
                            if ((t.push(i), s)) for (var n = 0; n < s.length; n++) t.push(s[n].getAttribute("data-variant-secondary-option"));
                            var r = t.join(" / "),
                                a = document.querySelectorAll('[data-variant-slide-option*="'.concat(r, '"]'))[0];
                            if (a) {
                                var o = document.querySelector(".Product__SlideItem--image.is-selected");
                                (o.style.opacity = "0"),
                                    (this.activeHover = a),
                                    (this.origX = this.activeHover.style.left),
                                    (this.activeHover.style.left = o.style.left),
                                    (this.activeHover.style.opacity = "1"),
                                    (this.activeHover.style.zIndex = "1");
                            }
                        }
                    },
                },
                {
                    key: "_hideHoverImage",
                    value: function () {
                        (document.querySelector(".Product__SlideItem--image.is-selected").style.opacity = ""),
                            this.activeHover && ((this.activeHover.style.zIndex = ""), (this.activeHover.style.opacity = ""), (this.activeHover.style.left = this.origX), (this.origX = null), (this.activeHover = null));
                    },
                },
                {
                    key: "mapInputOptions",
                    value: function (e, t) {
                        for (var i = 0; i < e.length; i++)
                            if (e[i].querySelector('input[type="radio"]').checked) {
                                var s = t[i],
                                    n = s.querySelector('input[type="radio"]');
                                s.classList.add("is-selected"), (n.checked = !0);
                            } else t[i].classList.remove("is-selected");
                    },
                },
                {
                    key: "destroyMayaHoverSwatches",
                    value: function () {
                        if (this.hoverSwatches) {
                            for (var e = 0; e < this.hoverSwatches.length; e++) this.hoverSwatches[e].destroy();
                            this.hoverSwatches = [];
                        }
                    },
                },
            ]),
            t
        );
    })()),
        document.addEventListener("DOMContentLoaded", function () {
            new a().initialize();
        });
})();

document.addEventListener("DOMContentLoaded", function () {


let custom_engraving_fieldEls = document.querySelectorAll(".engraving_input");
  if(custom_engraving_fieldEls.length) {

    custom_engraving_fieldEls.forEach(function(custom_engraving_fieldEl,index) {
      
   
    custom_engraving_fieldEl.addEventListener('input', function(e){    
     let value = this.value;
    let row_title = this.getAttribute('data-title');
    let custom_engraving_main_fieldEl;
      if(row_title.indexOf('left') >= 0)  {
        custom_engraving_main_fieldEl = document.querySelector('#custom_engraving_left_field');
      } else {
        custom_engraving_main_fieldEl = document.querySelector('#custom_engraving_right_field');
      }
      if(custom_engraving_main_fieldEl) {
        custom_engraving_main_fieldEl.value = value;
      }
  });
       });
  }





  
  var mainNavLinks = document.querySelectorAll('.main-nav-link-root');
  var mainMenu = document.querySelector('#MainHeader');
  for (var i = 0; i < mainNavLinks.length; i++) {
    if (mainNavLinks[i] != null) {
      mainNavLinks[i].addEventListener('mouseenter', function(e) {
        this.classList.add('is-expanded');
      });
      
      mainNavLinks[i].addEventListener('click', function(e) {
        e.preventDefault();
      });
    }
  }

  if (mainMenu != null) {
    mainMenu.addEventListener('mouseleave', function(e) {
      for (var i = 0; i < mainNavLinks.length; i++) {
        if (mainNavLinks[i] != null) {
          mainNavLinks[i].classList.remove('is-expanded');
        }
  }
    });
  }
  
  var Faq__Questions = document.querySelectorAll('.Faq__Question');
  var Faq__Summarys = document.querySelectorAll('.FaqSummary__Item');
  for (var i = 0; i < Faq__Questions.length; i++) {
    Faq__Questions[i].addEventListener('click', function(e) {
      toggleItem(e,e.target)
    });
  }
  
  for (var i = 0; i < Faq__Summarys.length; i++) {
    Faq__Summarys[i].addEventListener('click', function(e) {
      switchToCategory(e,e.target.closest('.FaqSummary__Item'))
    });
  }
  
  function switchToCategory(event, target) {
    target.classList.add('is-active');

    getSiblings(target, '.is-active').forEach(function (item) {
      item.classList.remove('is-active');
    });
  }
  
  function toggleItem(event, target) {
    var item = target.closest('.Faq__Item');

    if (item.getAttribute('aria-expanded') === 'true') {
      closeItem(item);
    } else {
      openItem(item);
    }
  }
  
  function openItem(item) {
    var answerWrapper = item.querySelector('.Faq__AnswerWrapper');

    item.setAttribute('aria-expanded', 'true');

    answerWrapper.setAttribute('aria-hidden', 'false');
    slideDown(answerWrapper, true);

    getSiblings(item, '[aria-expanded="true"]').forEach(function (siblingItem) {
      var siblingAnswerWrapper = siblingItem.querySelector('.Faq__AnswerWrapper');

      siblingItem.setAttribute('aria-expanded', 'false');

      siblingAnswerWrapper.setAttribute('aria-hidden', 'true');
      slideUp(siblingAnswerWrapper);
    });
  }
  
  function closeItem(item) {
    var answerWrapper = item.querySelector('.Faq__AnswerWrapper');

    item.setAttribute('aria-expanded', 'false');
    answerWrapper.setAttribute('aria-hidden', 'true');
    slideUp(answerWrapper);
  }

  function slideUp(element) {
    element.style.height = element.scrollHeight + 'px'; // Force previous height to allow CSS transition
    element.offsetHeight; // Force redraw
    element.style.height = 0;
  }
  
  function slideDown(element) {
    if (element.style.height === 'auto') {
      return;
    }

    // To do the animation we temporarily hide it, check the height, and transition to it
    element.style.height = element.firstElementChild.scrollHeight + 'px';

    var transitionEnded = function transitionEnded(event) {
      if (event.propertyName === 'height') {
        element.style.height = 'auto'; // Allows the content to grow normally
        element.removeEventListener('transitionend', transitionEnded);
      }
    };

    element.addEventListener('transitionend', transitionEnded);
  }

  document.addEventListener('click', function(e) {

    if (e.target.closest('[href^="#"]') != null || e.target.closest('[data-href]') != null) {
      if (e.target.closest('[href^="#"]') != null) {
        var target = e.target.closest('[href^="#"]');
      } else if (e.target.closest('[data-href]') != null) {
        var target = e.target.closest('[data-href]');
      }
      
      var announcementBar = document.querySelector('.AnnouncementBar');
      var selector = target.hasAttribute('href') ? target.getAttribute('href') : target.getAttribute('data-href');

      if (selector === '#' || selector == "#recover" || selector == "#login") {
        return;
      }

      var element = document.querySelector(selector),
          offset = parseInt(target.getAttribute('data-offset') || 0);

      if (announcementBar) {
        offset -= announcementBar.clientHeight;
      }

      window.scrollTo({ behavior: 'smooth', top: element.offsetTop - offset });

      e.preventDefault();
    }
  });
  
  function getSiblings(element, filter) {
    var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var siblings = [];
    var currentElement = element;

    // Do the previous first
    while (currentElement = currentElement.previousElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    }

    // Then the next side
    currentElement = element;

    while (currentElement = currentElement.nextElementSibling) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }
  
  var productCardSwatches = document.querySelectorAll('.prod-card-color-options-item');
  for (var i = 0; i < productCardSwatches.length; i++) {
    
    productCardSwatches[i].addEventListener('mouseenter', function(e) {
      var parentElement = e.target.closest('.product-card');
      var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
      var mainImageParent = parentElement.querySelector('.product-card-main-image');
      var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
      var imgAlt = e.target.getAttribute('data-img-alt');
      var imgWidth = e.target.getAttribute('data-img-width');
      var imgHeight = e.target.getAttribute('data-img-height');
      var imgSrc = e.target.getAttribute('data-img-src');
      var imgSrcset = e.target.getAttribute('data-img-srcset');
      
      if (hoverImage != null) {
        hoverImage.setAttribute('alt',imgAlt);
        hoverImage.setAttribute('width',imgWidth);
        hoverImage.setAttribute('height',imgHeight);
        hoverImage.setAttribute('src',imgSrc);
        hoverImage.setAttribute('srcset',imgSrcset);
      }
      
      if (hoverImageParent != null) {
        hoverImageParent.classList.add('show');
      }
      
      if (mainImageParent != null) {
        mainImageParent.classList.add('hide');
      }
    });
    
    productCardSwatches[i].addEventListener('mouseleave', function(e) {  
      var parentElement = e.target.closest('.product-card');
      var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
      var mainImageParent = parentElement.querySelector('.product-card-main-image');
      var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
      if (hoverImageParent != null) {
        hoverImageParent.classList.remove('show');
      }
      
      if (mainImageParent != null) {
        mainImageParent.classList.remove('hide');
      }
    });
    
    productCardSwatches[i].addEventListener('click', function(e) {
      e.preventDefault();
      
      var parentElement = e.target.closest('.product-card');
      var hoverImageParent = parentElement.querySelector('.product-card-hover-image');
      var mainImageParent = parentElement.querySelector('.product-card-main-image');
      var mainImage = parentElement.querySelector('.product-card-main-image > img');
      var hoverImage = parentElement.querySelector('.product-card-hover-image > img');
      var productCardLink = parentElement.querySelector('.product-card-link');
      var imgAlt = e.target.getAttribute('data-img-alt');
      var imgWidth = e.target.getAttribute('data-img-width');
      var imgHeight = e.target.getAttribute('data-img-height');
      var imgSrc = e.target.getAttribute('data-img-src');
      var imgSrcset = e.target.getAttribute('data-img-srcset');
      var variantLink = e.target.getAttribute('href');
      
      if (mainImage != null) {
        mainImage.setAttribute('alt',imgAlt);
        mainImage.setAttribute('width',imgWidth);
        mainImage.setAttribute('height',imgHeight);
        mainImage.setAttribute('src',imgSrc);
        mainImage.setAttribute('srcset',imgSrcset);
      }
      
      if (productCardLink != null) {
        productCardLink.setAttribute('href',variantLink);
      }
      
      for (var j = 0; j < productCardSwatches.length; j++) {
        productCardSwatches[j].classList.remove('is-active');
      }

      e.target.classList.add('is-active');
    });
  }
  

  var isPageLoaded;
  var pageTransition = document.querySelector('.PageTransition');

  function _onPageLoaded() {
    isPageLoaded = true;

    // If the merchant has enabled full page transitions, we display it
    if (pageTransition) {
      new TimelineLite().fromTo(pageTransition, 0.6, { autoAlpha: 1, ease: Linear.easeNone }, { autoAlpha: 0, ease: Linear.easeNone });
    }
  }
  function _onPageUnload(event, target) {
    if (event.defaultPrevented || event.metaKey || !pageTransition) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if(!target) {
		target = event.target;    
    }
    
    var href = target.href;
    if(!href) {
      href = event.target.closest('a').href;    
    }

    if (pageTransition) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = href;
        }
      });

      var logo = document.querySelector('.PageTransition > figure');

      timeline.fromTo(pageTransition, 0.3, { autoAlpha: 0, ease: Linear.easeNone }, { autoAlpha: 1, ease: Linear.easeNone });
      logo.classList.add('is-visible');
    }
  }

  function PageTransition() {

    isPageLoaded = document.readyState === 'complete' || document.readyState === 'loaded' || document.readyState === 'interactive';

    if (!isPageLoaded) {
      document.addEventListener('DOMContentLoaded', _onPageLoaded.bind(this));
    } else {
      _onPageLoaded();
    }

    var all_linksElems = document.querySelectorAll('a[href]:not([href^="/account/login"]):not([href^="/search"]):not([href^="/cart"]):not([href^="#"]):not([href^="javascript:"]):not([href^="mailto:"]):not([href^="tel:"]):not([target="_blank"])');
    if(all_linksElems.length) {
      all_linksElems.forEach(function (item,index) {
      	item.addEventListener('click', _onPageUnload.bind(this));
      });
    }
  }
  
  PageTransition();

  function matchesBreakpoint(breakpoint) {
    switch (breakpoint) {
//       case 'phone':
//         return window.matchMedia('screen and (max-width: 640px)').matches;

//       case 'tablet':
//         return window.matchMedia('screen and (min-width: 641px) and (max-width: 1007px)').matches;

//       case 'tablet-and-up':
//         return window.matchMedia('screen and (min-width: 641px)').matches;

//       case 'pocket':
//         return window.matchMedia('screen and (max-width: 1007px)').matches;

//       case 'lap':
//         return window.matchMedia('screen and (min-width: 1008px) and (max-width: 1279px)').matches;

      case 'lap-and-up':
        return window.matchMedia('screen and (min-width: 992px)').matches;

//       case 'desk':
//         return window.matchMedia('screen and (min-width: 1280px)').matches;

//       case 'widescreen':
//         return window.matchMedia('screen and (min-width: 1600px)').matches;
    }
  }
  
  function Popover(element, options) {
            
    var activator = options['activator'] || document.querySelector('[aria-controls="' + element.getAttribute('id') + '"]');
    var preferredPosition = options['preferredPosition'] || 'bottom';
    var isOpen = false;

    
    var onValueChanged = options['onValueChanged'] || function () {};
    var onOpen = options['onOpen'] || function () {};
    var onClose = options['onClose'] || function () {};

    var showOverlay = options['showOverlay'] === undefined ? true : options['showOverlay'];
    var pageOverlayElement = document.querySelector('.PageOverlay');

    
    var disableBodyScroll = function() {
      var t, e = !1, i = !1, n = function(t) {
        !1 !== i && t.target.closest(e) || t.preventDefault()
      }, r = function(e) {
        1 === e.targetTouches.length && (t = e.targetTouches[0].clientY)
      }, s = function(e) {
        if (1 === e.targetTouches.length) {
          var n = e.targetTouches[0].clientY - t;
          0 === i.scrollTop && n > 0 && e.preventDefault(),
            i.scrollHeight - i.scrollTop <= i.clientHeight && n < 0 && e.preventDefault()
        }
      };
      return function(t, o) {
        "undefined" != typeof o && (e = o,
                                    i = document.querySelector(o));
        var a = !1;
        try {
          window.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: function() {
              a = !0
            }
          }))
        } catch (l) {}
        !0 === t ? (i && (i.addEventListener("touchstart", r, !1),
                          i.addEventListener("touchmove", s, !1)),
                    document.body.addEventListener("touchmove", n, !!a && {
          capture: !1,
          passive: !1
        })) : (i && (i.removeEventListener("touchstart", r, !1),
                     i.removeEventListener("touchmove", s, !1)),
               document.body.removeEventListener("touchmove", n, !!a && {
          capture: !1,
          passive: !1
        }))
      }
    }();
    
    function popoverAttachListeners() {
      element.addEventListener('keyup', function(e) {
        popoverHandleKeyboard(e,isOpen);
      });
      activator.addEventListener('click', function() {
        popoverToggle(isOpen);
      });

      document.addEventListener('click', function(e) {
        if (e.target == element.querySelector('[data-action="close-popover"]')) {
          popoverClose(e)
        }
      });
      document.addEventListener('click', function(e) {
        if (e.target == element.querySelector('[data-action="select-value"]')) {
         popoverValueChanged(e)
        }
      });
    }

    function popoverHandleKeyboard(event,isOpen) {
      if (isOpen && event.keyCode === 27) {
        popoverClose(); 
      }
    }

    function popoverToggle(isOpen) {
      isOpen ? popoverClose() : popoverOpen();
    }

    function popoverOpen() {

      if (isOpen || activator.getAttribute('aria-controls') !== element.id) {
        return;
      }

      element.setAttribute('aria-hidden', 'false');
      activator.setAttribute('aria-expanded', 'true');
      disableBodyScroll(true, '[data-scrollable]');

      document.documentElement.classList.add('no-scroll'); // Prevent scrolling when popover is open


      if (matchesBreakpoint('lap-and-up')) {
        document.body.addEventListener('click', function(e) {
          popoverClickOutside(e,activator)
        });
        popoverPosition();
      } else {
        element.removeAttribute('style');

        if (showOverlay) {
          pageOverlayElement.classList.add('is-visible');
          pageOverlayElement.addEventListener('click', popoverClose);
        }
      }
      isOpen = true;
    }

    function popoverClose() {
      if (!isOpen) {
        return;
      }

      element.setAttribute('aria-hidden', 'true');
      activator.setAttribute('aria-expanded', 'false');

      disableBodyScroll(false, '[data-scrollable]');

      document.documentElement.classList.remove('no-scroll');

      if (matchesBreakpoint('lap-and-up')) {
        document.body.removeEventListener('click', function(e) {
          popoverClickOutside(e,activator)
        });
      } else if (showOverlay) {
        pageOverlayElement.classList.remove('is-visible');
        pageOverlayElement.removeEventListener('click', popoverClose);
      }
      isOpen = false;
    }

    function popoverValueChanged(event) {
      getSiblings(event.target, '.is-selected').forEach(function (item) {
        return item.classList.remove('is-selected');
      });
      event.target.classList.add('is-selected');

      // If there is a callback in option we call it with the value
      onValueChanged(event.target.getAttribute('data-value'), event.target, activator);
      popoverClose()
    }

    function popoverClickOutside(event,activator) {
      
      if (!event.target.closest('.Popover') && !event.target.closest('.Modal') && event.target !== activator && !activator.contains(event.target)) {
        popoverClose();
      }
    }

    function popoverPosition() {

      var topPosition = 0,
          rightPosition = 0,
          position = '',
          alignment = '',
          threshold = 20;

      fastdom.measure(function () {
        var windowHeight = window.innerHeight,
            activatorBoundingRect = activator.getBoundingClientRect(),
            halfHeight = windowHeight / 2;

        
        if (preferredPosition === 'bottom') {
          alignment = 'right';

          if (element.clientHeight <= windowHeight - (activatorBoundingRect.bottom + threshold) || windowHeight - activatorBoundingRect.bottom >= halfHeight) {
            position = 'bottom';
          } else {
            position = 'top';
          }
        } else if (preferredPosition === 'top') {
          alignment = 'right';

          if (element.clientHeight <= activatorBoundingRect.top - threshold || activatorBoundingRect.top >= halfHeight) {
            position = 'top';
          } else {
            position = 'bottom';
          }
        } else {
          position = 'left';

          // Is there enough space to use the center alignment (which is preferred)?
          var halfElementHeight = element.clientHeight / 2;

          if (activatorBoundingRect.top >= halfElementHeight && windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'center';
          } else if (windowHeight - activatorBoundingRect.bottom >= halfElementHeight) {
            alignment = 'bottom';
          } else {
            alignment = 'top';
          }
        }

        
        var rightOffset = 15;
        
        if (position === 'top') {
          topPosition = activatorBoundingRect.top - element.clientHeight - threshold;
          rightPosition = window.innerWidth - activatorBoundingRect.right - rightOffset;
        } else if (position === 'bottom') {
          topPosition = activatorBoundingRect.bottom + threshold;
          rightPosition = window.innerWidth - activatorBoundingRect.right - rightOffset;
        } else {
          rightPosition = window.innerWidth - activatorBoundingRect.left + threshold;

          if (alignment === 'center') {
            topPosition = activatorBoundingRect.top - element.clientHeight / 2 + activator.clientHeight / 2;
          } else if (alignment === 'top') {
            topPosition = activatorBoundingRect.bottom - element.clientHeight;
          } else {
            topPosition = activatorBoundingRect.top;
          }
        }
      });

      fastdom.mutate(function () {
                
        ['Popover--positionBottom', 'Popover--positionTop', 'Popover--positionCenter', 'Popover--alignTop', 'Popover--alignCenter', 'Popover--alignBottom'].map(function (item) {
          return element.classList.remove(item);
        });
        element.classList.add('Popover--position' + (position.charAt(0).toUpperCase() + position.slice(1)));
        element.classList.add('Popover--align' + (alignment.charAt(0).toUpperCase() + alignment.slice(1)));

        element.setAttribute('style', 'top: ' + parseInt(topPosition) + 'px; right: ' + parseInt(rightPosition) + 'px;');
      });
    }
    
    popoverAttachListeners();
  }


  function getSiblings(element, filter) {
				var includeSelf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
		
				var siblings = [];
				var currentElement = element;
		
				// Do the previous first
				while (currentElement = currentElement.previousElementSibling) {
				if (!filter || currentElement.matches(filter)) {
					siblings.push(currentElement);
				}
				}
		
				if (includeSelf) {
				siblings.push(element);
				}
		
				// Then the next side
				currentElement = element;
		
				while (currentElement = currentElement.nextElementSibling) {
				if (!filter || currentElement.matches(filter)) {
					siblings.push(currentElement);
				}
				}
		
				return siblings;
			}
  
  // Create the popover if available
  var sortPopoverElement = document.getElementById('collection-sort-popover');
  if (sortPopoverElement) {
    Popover(sortPopoverElement, {});
    
    sortPopoverElement.addEventListener('click', function(e) {
      var target = e.target;
      
      if(target.getAttribute('data-action') == 'select-value') {

       getSiblings(target, '.is-selected').forEach(function (item) {
          return item.classList.remove('is-selected');
        });
        target.classList.add('is-selected');
        
        var val = target.getAttribute('data-value');
        var sort_by_selectEl = document.querySelector('[name="sort_by"]');
        if(sort_by_selectEl) {
          sort_by_selectEl.value = val;
          sort_by_selectEl.dispatchEvent(new Event('change', { bubbles: true }));
          
          var PopoverParentEl = target.closest('.Popover');
          if(PopoverParentEl) {
            var closeBtnEl = PopoverParentEl.querySelector('[data-action="close-popover"]');
            if(closeBtnEl) {
              closeBtnEl.dispatchEvent(new Event('click', { bubbles: true }));
            }
          }
        }

      }
    });
  }
  
  var collection_filters_popoverEl = document.getElementById('collection-filters-popover'); 
  if(collection_filters_popoverEl) {
    Popover(collection_filters_popoverEl, { preferredPosition: 'bottom',});
  }



  function CountrySelector(countrySelect, provinceSelect) {

    var _this = {};
    _this.countrySelect = countrySelect;
    _this.provinceSelect = provinceSelect;


    if (_this.countrySelect && _this.provinceSelect) {

      function _onCountryChanged() {

        var selectedOption = _this.countrySelect.options[_this.countrySelect.selectedIndex],
            provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');

        // First remove all options
        _this.provinceSelect.innerHTML = '';

        if (provinces.length === 0) {
          _this.provinceSelect.parentNode.style.display = 'none';
          return;
        }

        // We need to build the provinces array
        provinces.forEach(function (data) {
          _this.provinceSelect.options.add(new Option(data[1], data[0]));
        });

        _this.provinceSelect.parentNode.style.display = 'block';
      }

      _this.countrySelect.addEventListener('change', _onCountryChanged);

      // Check first the default value of country
      var defaultCountry = _this.countrySelect.getAttribute('data-default');

      if (defaultCountry) {
        for (var i = 0; i !== _this.countrySelect.options.length; ++i) {
          if (_this.countrySelect.options[i].text === defaultCountry) {
            _this.countrySelect.selectedIndex = i;
            break;
          }
        }
      } else {
        _this.countrySelect.selectedIndex = 0;
      }

      var event = new Event('change', { bubbles: true });
      _this.countrySelect.dispatchEvent(event);

      // Then the province
      var defaultProvince = _this.provinceSelect.getAttribute('data-default');

      if (defaultProvince) {
        _this.provinceSelect.value = defaultProvince;
      }

    }
  }

  function formatMoney(cents, format) {
				if (typeof cents === 'string') {
				cents = cents.replace('.', '');
				}
		
				var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
					formatString = format || '${{amount}}';
		
				function defaultTo(value, defaultValue) {
				return value == null || value !== value ? defaultValue : value;
				}
		
				function formatWithDelimiters(number, precision, thousands, decimal) {
				precision = defaultTo(precision, 2);
				thousands = defaultTo(thousands, ',');
				decimal = defaultTo(decimal, '.');
		
				if (isNaN(number) || number == null) {
					return 0;
				}
		
				number = (number / 100.0).toFixed(precision);
		
				var parts = number.split('.'),
					dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
					centsAmount = parts[1] ? decimal + parts[1] : '';
		
				return dollarsAmount + centsAmount;
				}
		
				var value = '';
		
				switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_space_separator':
					value = formatWithDelimiters(cents, 2, ' ', '.');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, ',', '.');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				}
		
				if (formatString.indexOf('with_comma_separator') !== -1) {
				return formatString.replace(placeholderRegex, value).replace(',00', '');
				} else {
				return formatString.replace(placeholderRegex, value).replace('.00', '');
				}
			}

  function ShippingEstimator(element) {

    var _this = {};

    _this.element = element;
    _this.countrySelector = CountrySelector(_this.element.querySelector('[name="country"]'), _this.element.querySelector('[name="province"]'));

    function _fetchRates() {

      var country = _this.element.querySelector('[name="country"]').value,
          province = _this.element.querySelector('[name="province"]').value,
          zip = _this.element.querySelector('[name="zip"]').value;

		
      
      fetch(window.theme.localeRootUrl + '/cart/shipping_rates.json?shipping_address[zip]=' + zip + '&shipping_address[country]=' + country + '&shipping_address[province]=' + province, {
        credentials: 'same-origin',
        method: 'GET'
      }).then(function (response) {
        response.json().then(function (result) {

          
          var resultsContainer = _this.element.querySelector('.ShippingEstimator__Results'),
              errorContainer = _this.element.querySelector('.ShippingEstimator__Error');

          if (response.ok) {
            var shippingRates = result['shipping_rates'];

            if (shippingRates.length === 0) {
              resultsContainer.innerHTML = '<p>' + window.languages.shippingEstimatorNoResults + '</p>';
            } else {
              var html = '';

              if (shippingRates.length === 1) {
                html += '<p>' + window.languages.shippingEstimatorOneResult + '</p><ul>';
              } else {
                html += '<p>' + window.languages.shippingEstimatorMoreResults.replace('{{count}}', shippingRates.length) + '</p><ul>';
              }

              shippingRates.forEach(function (item) {
                html += '<li>' + item['name'] + ': ' + formatMoney(item['price'], window.theme.moneyFormat) + '</li>';
              });

              html += '</ul>';

              resultsContainer.firstElementChild.innerHTML = html;
            }

            TweenLite.fromTo(resultsContainer.firstElementChild, 0.6, { autoAlpha: 0, y: -15 }, { autoAlpha: 1, y: 0, delay: 0.35 });

            errorContainer.style.display = 'none';
            resultsContainer.style.display = 'block';

            slideDown(resultsContainer);
          } else {
            var errorHtml = '';

            Object.keys(result).forEach(function (key) {
              errorHtml += '<li class="Alert__ErrorItem">' + key + ' ' + result[key] + '</li>';
            });

            errorContainer.innerHTML = '<ul class="Alert__ErrorList">' + errorHtml + '</ul>';

            resultsContainer.style.display = 'none';
            errorContainer.style.display = 'block';
          }
        });
      });
    }

    var ShippingEstimator__SubmitEl = _this.element.querySelector('.ShippingEstimator__Submit');
    if(ShippingEstimator__SubmitEl) {
    	ShippingEstimator__SubmitEl.addEventListener('click', _fetchRates);
    }
  }

  var ShippingEstimatorEl = document.querySelector('.ShippingEstimator');
  if(ShippingEstimatorEl) {
    ShippingEstimator(ShippingEstimatorEl);
  }

});

document.addEventListener("DOMContentLoaded", function(event) { 
  var cartComplimentaryAdditionalItemPopupRadios = document.querySelectorAll('.cart-complimentary-additional-item-popup-content-radios input');
  if (cartComplimentaryAdditionalItemPopupRadios.length) {
    cartComplimentaryAdditionalItemPopupRadios.forEach(function(item){
      item.addEventListener("change", function(event) {
        var _this = this;
        if (this.getAttribute('id') == 'complimentaryAddon1' && this.checked == true) {
          cartComplimentaryAdditionalItemPopupRadios.forEach(function(el){
            if (item != el) {
              el.checked = false;
            }
          });
        }

        if (this.getAttribute('id') == 'complimentaryAddon2' && this.checked == true) {
          cartComplimentaryAdditionalItemPopupRadios.forEach(function(el){
            if (el.getAttribute('id') == 'complimentaryAddon1') {
              el.checked = false;
            }
          });
        }

        if (this.getAttribute('id') == 'complimentaryAddon3' && this.checked == true) {
          cartComplimentaryAdditionalItemPopupRadios.forEach(function(el){
            if (el.getAttribute('id') == 'complimentaryAddon1') {
              el.checked = false;
            }
          });
        }
      });
    });
  }
});


















